import { withAppCrashIfException } from 'epic';
import { batchImportFormEpic } from 'epic/batchWorkspace/formOperations/Import/batchImportFormEpic';
import { tradeAuthorizationEpic } from 'epic/batchWorkspace/tradeAuthorizationEpic';
import { combineEpics } from 'redux-observable';

import { batchFormEnrichmentRequestedEpic } from './batchWorkspaceEnrichmentRequestedEpic';
import { cloneFormsEpic } from './cloneBatchFormEpic';
import { deleteFormsEpic } from './deleteBatchFormsEpic';
import { fetchBatchFormWhenQuoteReloadEpic } from './fetchBatchFormWhenQuoteReprice';
import { fetchBatchWorkspaceTabsEpic } from './fetchBatchWorkspaceTabsEpic';
import { fetchDefaultBatchFormEpic } from './fetchDefaultBatchFormEpic';
import { batchImportMetadataEpic } from './formOperations/Import/batchImportMetadataEpic';
import { navigateToBatchWorkspaceEpic } from './navigateToBatchWorkspaceEpic';
import { persistBatchWorkspaceTabContentEpic } from './persistBatchWorkspaceTabContentEpic';
import { persistBatchWorkspaceTabContentOnTabResetCompletedEpic } from './persistBatchWorkspaceTabContentOnTabResetCompletedEpic';
import { persistBatchWorkspaceTabOnResetCompletedEpic } from './persistBatchWorkspaceTabOnResetCompletedEpic';
import { batchPricingQueueEpics } from './pricingConflationEpics';
import { reloadBatchFormEpic } from './reloadBatchFormEpic';
import { removeBatchQuote } from './removeBatchQuoteEpic';
import { batchRestoreFormQueueEpics } from './restoreFormConflationEpics';

export const batchWorkspaceEpic = () =>
  withAppCrashIfException(
    'batchWorkspaceEpic',
    combineEpics(
      withAppCrashIfException('fetchBatchWorkspaceTabsEpic', fetchBatchWorkspaceTabsEpic()),
      withAppCrashIfException('fetchDefaultBatchFormEpic', fetchDefaultBatchFormEpic()),
      withAppCrashIfException('persistBatchWorkspaceTabContentEpic', persistBatchWorkspaceTabContentEpic()),
      withAppCrashIfException(
        'persistBatchWorkspaceTabContentOnTabResetCompletedEpic',
        persistBatchWorkspaceTabContentOnTabResetCompletedEpic(),
      ),
      withAppCrashIfException(
        'persistBatchWorkspaceTabOnResetCompletedEpic',
        persistBatchWorkspaceTabOnResetCompletedEpic(),
      ),
      withAppCrashIfException('batchFormEnrichmentRequestedEpic', batchFormEnrichmentRequestedEpic()),
      withAppCrashIfException('batchImportMetadataEpic', batchImportMetadataEpic()),
      withAppCrashIfException('batchImportFormEpic', batchImportFormEpic()),
      withAppCrashIfException('deleteFormsEpic', deleteFormsEpic()),
      withAppCrashIfException(
        'addFormToQueueOnPricingRequestedEpic',
        batchPricingQueueEpics.addFormToQueueOnPricingRequestedEpic(),
      ),
      withAppCrashIfException('priceFormEpic', batchPricingQueueEpics.priceFormEpic()),
      withAppCrashIfException('quoteResultReceivedEpic', batchPricingQueueEpics.quoteResultReceivedEpic()),
      withAppCrashIfException('cancelQuotePushBackEpic', batchPricingQueueEpics.cancelQuotePushBackEpic()),
      withAppCrashIfException('removeBatchQuote', removeBatchQuote()),
      withAppCrashIfException('cloneFormsEpic', cloneFormsEpic()),
      withAppCrashIfException('fetchBatchFormWhenQuoteReloadEpic', fetchBatchFormWhenQuoteReloadEpic()),
      withAppCrashIfException(
        'addLoadingFormsOnTabContentRestoredEpic',
        batchRestoreFormQueueEpics.addLoadingFormsOnTabContentRestoredEpic(),
      ),
      withAppCrashIfException('restoreFormEpic', batchRestoreFormQueueEpics.restoreFormEpic()),
      withAppCrashIfException(
        'addItemToQueueOnRollbackEpic',
        batchRestoreFormQueueEpics.addItemToQueueOnRollbackEpic(),
      ),
      withAppCrashIfException('reloadBatchFormEpic', reloadBatchFormEpic()),
      withAppCrashIfException('abortQuoteEpic', batchPricingQueueEpics.abortQuoteEpic()),
      withAppCrashIfException('navigateToBatchWorkspaceEpic', navigateToBatchWorkspaceEpic()),
      withAppCrashIfException('tradeAuthorizationEpic', tradeAuthorizationEpic()),
    ),
  );
